import { Text } from '@chakra-ui/react'
import { getDisplayMessage } from 'components/api/displayMessage'
import type { FC } from 'react'

import { Loader } from '../../../copilot/components/Loader'
import { Conversations } from './Conversations'
import { usePreviousInteractions } from './usePreviousInteractions'

type Props = { customer: string; apiToken: string; showContent: boolean }

export const PreviousInteractions: FC<Props> = ({
  apiToken,
  customer,
  showContent,
}) => {
  const { data, error, isLoading } = usePreviousInteractions(apiToken, {
    customers: [customer],
  })
  if (!showContent) return null

  if (isLoading) return <Loader />
  if (!data) return null
  if (error) return <Text>{getDisplayMessage(error)}</Text>

  return (data || [])
    .toReversed()
    .map(([date, conversations]) => (
      <Conversations conversations={conversations} date={date} key={date} />
    ))
}
